'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var reactRedux = require('react-redux');
var isEqual = require('react-fast-compare');
var mstSentry = require('@zillow/mst-sentry');
var toolkit = require('@reduxjs/toolkit');

function _interopDefault (e) { return e && e.__esModule ? e["default"] : e; }

var React__default = /*#__PURE__*/_interopDefault(React);
var isEqual__default = /*#__PURE__*/_interopDefault(isEqual);

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

var MERGE_AD_STATE = 'MERGE_AD_STATE';

var INITIALIZED_STORE = 'INITIALIZED_STORE';
var SRP_STATE_UPDATED = 'SRP_STATE_UPDATED';
var AD_SLOT_REQUESTED = 'AD_SLOT_REQUESTED';

// ad slot constants
var AD_SLOTS = {
  RENTAL: 'rental',
  NAV: 'nav',
  DISPLAY: 'display',
  NAV2: 'nav2'
};
var MIN_ZIP_COUNT = 3;
var RENTAL_SECOND_AD_VERS = 'srp_2nd_a';
var SENTRY = {
  DSN: 'https://adf0614191d9dc2ed8ccb0de95b3dabc@o168728.ingest.us.sentry.io/4508774151290881',
  PROJECT_NAME: 'mst-machina'
};

var versAppend = function versAppend(vers, value) {
  var appendedVers = vers || '';
  if (appendedVers.length > 0) {
    appendedVers += ',';
  }
  appendedVers += value;
  return appendedVers;
};
var isHomeTypeFilterChange = function isHomeTypeFilterChange(previousFilterState, currentFilterState) {
  return previousFilterState.isTownHouse !== currentFilterState.isTownHouse || previousFilterState.isCondo !== currentFilterState.isCondo || previousFilterState.isApartmentOrCondo !== currentFilterState.isApartmentOrCondo || previousFilterState.isLotLand !== currentFilterState.isLotLand || previousFilterState.isApartment !== currentFilterState.isApartment || previousFilterState.isMultiFamily !== currentFilterState.isMultiFamily || previousFilterState.isManufactured !== currentFilterState.isManufactured || previousFilterState.isSingleFamily !== currentFilterState.isSingleFamily;
};
var getStateChanges = function getStateChanges(previousState, currentState) {
  var _previousState$adsCon, _previousState$adsCon2, _currentState$adsConf, _currentState$adsConf2;
  var mapBoundsChanged = !isEqual__default(previousState.queryState.mapBounds, currentState.queryState.mapBounds);
  var filterStateChanged = !isEqual__default(previousState.queryState.filterState, currentState.queryState.filterState);
  var mapZoomChanged = !isEqual__default(previousState.queryState.mapZoom, currentState.queryState.mapZoom);
  var categoryChanged = !isEqual__default(previousState.queryState.category, currentState.queryState.category);
  var adRestrictedChanged = !isEqual__default(previousState.isAdRestricted, currentState.isAdRestricted);
  var searchResultsChanged = previousState.searchResultState.resultsHash !== currentState.searchResultState.resultsHash;
  var pageChanged = !isEqual__default(previousState.queryState.pagination, currentState.queryState.pagination);
  var zipCodeChanged = ((_previousState$adsCon = previousState.adsConfig) === null || _previousState$adsCon === void 0 ? void 0 : (_previousState$adsCon2 = _previousState$adsCon.targets) === null || _previousState$adsCon2 === void 0 ? void 0 : _previousState$adsCon2.zip) !== ((_currentState$adsConf = currentState.adsConfig) === null || _currentState$adsConf === void 0 ? void 0 : (_currentState$adsConf2 = _currentState$adsConf.targets) === null || _currentState$adsConf2 === void 0 ? void 0 : _currentState$adsConf2.zip);
  var abTrialStateChanged = !isEqual__default(previousState.adAbTrialState, currentState.adAbTrialState);
  var regionSelectionChanged = !isEqual__default(previousState.queryState.regionSelection, currentState.queryState.regionSelection);
  var userSearchTermChanged = previousState.queryState.usersSearchTerm !== currentState.queryState.usersSearchTerm;
  return {
    mapBoundsChanged: mapBoundsChanged,
    filterStateChanged: filterStateChanged,
    mapZoomChanged: mapZoomChanged,
    categoryChanged: categoryChanged,
    adRestrictedChanged: adRestrictedChanged,
    searchResultsChanged: searchResultsChanged,
    pageChanged: pageChanged,
    zipCodeChanged: zipCodeChanged,
    abTrialStateChanged: abTrialStateChanged,
    regionSelectionChanged: regionSelectionChanged,
    userSearchTermChanged: userSearchTermChanged
  };
};
var isEligibleForZipCodeRefresh = function isEligibleForZipCodeRefresh(state) {
  var _state$adsConfig, _state$adsConfig$targ, _state$adsConfig$targ2, _state$adsConfig$targ3;
  var zipLength = (_state$adsConfig = state.adsConfig) === null || _state$adsConfig === void 0 ? void 0 : (_state$adsConfig$targ = _state$adsConfig.targets) === null || _state$adsConfig$targ === void 0 ? void 0 : (_state$adsConfig$targ2 = _state$adsConfig$targ.zip) === null || _state$adsConfig$targ2 === void 0 ? void 0 : (_state$adsConfig$targ3 = _state$adsConfig$targ2.split(',')) === null || _state$adsConfig$targ3 === void 0 ? void 0 : _state$adsConfig$targ3.length;
  if (zipLength === undefined) {
    return false;
  }
  return zipLength >= MIN_ZIP_COUNT;
};
var collectAndSortRegionIds = function collectAndSortRegionIds(state) {
  var regionSelection = state.queryState.regionSelection;
  if (!regionSelection) {
    return [];
  }
  regionSelection = state.queryState.regionSelection.filter(function (region) {
    return region === null || region === void 0 ? void 0 : region.regionId;
  }).map(function (region) {
    return region.regionId;
  });
  return _toConsumableArray(regionSelection).sort(function (a, b) {
    return a - b;
  });
};
var isRefreshFilterChange = function isRefreshFilterChange(state, action) {
  return action.stateChanges.filterStateChanged && (!isEqual__default(action.previousFilterState.price, state.queryState.filterState.price) || !isEqual__default(action.previousFilterState.sqft, state.queryState.filterState.sqft) || !isHomeTypeFilterChange(action.previousFilterState, state.queryState.filterState) || !isEqual__default(action.previousFilterState.ageRestricted55Plus, state.queryState.filterState.ageRestricted55Plus));
};
var isSingleListingType = function isSingleListingType(filterState) {
  var _filterState$isComing;
  var isFSBO = filterState.isForSaleByOwner;
  var isFSBA = filterState.isForSaleByAgent;
  var isNewConstruction = filterState.isNewConstruction;
  var isComingSoon = (_filterState$isComing = filterState.isComingSoon) === null || _filterState$isComing === void 0 ? void 0 : _filterState$isComing.value;
  var isForeclosure = filterState.isPreMarketForeclosure || filterState.isPreMarketPreForeclosure || filterState.isForSaleForeclosure || filterState.isAuction;
  var isRecentlySold = filterState.isRecentlySold;
  var isForRent = filterState.isForRent;
  var isSingleChecked = (isFSBA ? 1 : 0) + (isFSBO ? 1 : 0) + (isNewConstruction ? 1 : 0) + (isComingSoon ? 1 : 0) + (isForeclosure ? 1 : 0) + (isRecentlySold ? 1 : 0) + (isForRent ? 1 : 0) === 1;
  return {
    isSingleChecked: isSingleChecked,
    isFSBO: isFSBO,
    isFSBA: isFSBA,
    isNewConstruction: isNewConstruction,
    isComingSoon: isComingSoon,
    isForeclosure: isForeclosure,
    isRecentlySold: isRecentlySold,
    isForRent: isForRent
  };
};
var isListingTypeFilterChange = function isListingTypeFilterChange(previousFilterState, currentFilterState) {
  var previousListingType = isSingleListingType(previousFilterState);
  var currentListingType = isSingleListingType(currentFilterState);
  return previousFilterState.isForRent !== currentFilterState.isForRent || previousFilterState.isRecentlySold !== currentFilterState.isRecentlySold || previousListingType.isSingleChecked !== currentListingType.isSingleChecked || currentListingType.isSingleChecked && !isEqual__default(previousListingType, currentListingType);
};

function adStateFromSrpState(srpState, abTrialMappings) {
  var _srpState$queryState$, _filterState$isAuctio, _filterState$isAuctio2, _filterState$isForSal, _filterState$isForSal2, _filterState$isNewCon, _filterState$isNewCon2, _filterState$isForSal3, _filterState$isForSal4, _filterState$isForSal5, _filterState$isForSal6, _filterState$isPreMar, _filterState$isPreMar2, _filterState$isPreMar3, _filterState$isPreMar4, _filterState$isForRen, _filterState$isForRen2, _filterState$isRecent, _filterState$isRecent2, _filterState$isTownHo, _filterState$isTownHo2, _filterState$isCondo$, _filterState$isCondo, _filterState$isApartm, _filterState$isApartm2, _filterState$isLotLan, _filterState$isLotLan2, _filterState$isApartm3, _filterState$isApartm4, _filterState$isMultiF, _filterState$isMultiF2, _filterState$isManufa, _filterState$isManufa2, _filterState$isSingle, _filterState$isSingle2, _srpState$searchResul, _srpState$searchResul2, _srpState$searchResul3, _srpState$searchResul4, _srpState$isAdsRestri, _srpState$metadata, _srpState$searchPageC, _srpState$searchPageC2, _srpState$searchPageC3, _srpState$searchPageC4;
  if (abTrialMappings === void 0) {
    abTrialMappings = {};
  }
  var filterState = srpState.queryState.filterState;
  var queryState = Object.assign({}, srpState.queryState, {
    category: (_srpState$queryState$ = srpState.queryState.category) !== null && _srpState$queryState$ !== void 0 ? _srpState$queryState$ : 'cat1',
    filterState: Object.assign({}, filterState, {
      isAuction: (_filterState$isAuctio = (_filterState$isAuctio2 = filterState.isAuction) === null || _filterState$isAuctio2 === void 0 ? void 0 : _filterState$isAuctio2.value) !== null && _filterState$isAuctio !== void 0 ? _filterState$isAuctio : true,
      isForSaleForeclosure: (_filterState$isForSal = (_filterState$isForSal2 = filterState.isForSaleForeclosure) === null || _filterState$isForSal2 === void 0 ? void 0 : _filterState$isForSal2.value) !== null && _filterState$isForSal !== void 0 ? _filterState$isForSal : true,
      isNewConstruction: (_filterState$isNewCon = (_filterState$isNewCon2 = filterState.isNewConstruction) === null || _filterState$isNewCon2 === void 0 ? void 0 : _filterState$isNewCon2.value) !== null && _filterState$isNewCon !== void 0 ? _filterState$isNewCon : true,
      isForSaleByAgent: (_filterState$isForSal3 = (_filterState$isForSal4 = filterState.isForSaleByAgent) === null || _filterState$isForSal4 === void 0 ? void 0 : _filterState$isForSal4.value) !== null && _filterState$isForSal3 !== void 0 ? _filterState$isForSal3 : true,
      isForSaleByOwner: (_filterState$isForSal5 = (_filterState$isForSal6 = filterState.isForSaleByOwner) === null || _filterState$isForSal6 === void 0 ? void 0 : _filterState$isForSal6.value) !== null && _filterState$isForSal5 !== void 0 ? _filterState$isForSal5 : true,
      isPreMarketForeclosure: (_filterState$isPreMar = (_filterState$isPreMar2 = filterState.isPreMarketForeclosure) === null || _filterState$isPreMar2 === void 0 ? void 0 : _filterState$isPreMar2.value) !== null && _filterState$isPreMar !== void 0 ? _filterState$isPreMar : false,
      isPreMarketPreForeclosure: (_filterState$isPreMar3 = (_filterState$isPreMar4 = filterState.isPreMarketPreForeclosure) === null || _filterState$isPreMar4 === void 0 ? void 0 : _filterState$isPreMar4.value) !== null && _filterState$isPreMar3 !== void 0 ? _filterState$isPreMar3 : false,
      isForRent: (_filterState$isForRen = (_filterState$isForRen2 = filterState.isForRent) === null || _filterState$isForRen2 === void 0 ? void 0 : _filterState$isForRen2.value) !== null && _filterState$isForRen !== void 0 ? _filterState$isForRen : false,
      isRecentlySold: (_filterState$isRecent = (_filterState$isRecent2 = filterState.isRecentlySold) === null || _filterState$isRecent2 === void 0 ? void 0 : _filterState$isRecent2.value) !== null && _filterState$isRecent !== void 0 ? _filterState$isRecent : false,
      // Home Types
      isTownHouse: (_filterState$isTownHo = (_filterState$isTownHo2 = filterState.isTownHouse) === null || _filterState$isTownHo2 === void 0 ? void 0 : _filterState$isTownHo2.value) !== null && _filterState$isTownHo !== void 0 ? _filterState$isTownHo : true,
      isCondo: (_filterState$isCondo$ = (_filterState$isCondo = filterState.isCondo) === null || _filterState$isCondo === void 0 ? void 0 : _filterState$isCondo.value) !== null && _filterState$isCondo$ !== void 0 ? _filterState$isCondo$ : true,
      isApartmentOrCondo: (_filterState$isApartm = (_filterState$isApartm2 = filterState.isApartmentOrCondo) === null || _filterState$isApartm2 === void 0 ? void 0 : _filterState$isApartm2.value) !== null && _filterState$isApartm !== void 0 ? _filterState$isApartm : true,
      isLotLand: (_filterState$isLotLan = (_filterState$isLotLan2 = filterState.isLotLand) === null || _filterState$isLotLan2 === void 0 ? void 0 : _filterState$isLotLan2.value) !== null && _filterState$isLotLan !== void 0 ? _filterState$isLotLan : true,
      isApartment: (_filterState$isApartm3 = (_filterState$isApartm4 = filterState.isApartment) === null || _filterState$isApartm4 === void 0 ? void 0 : _filterState$isApartm4.value) !== null && _filterState$isApartm3 !== void 0 ? _filterState$isApartm3 : true,
      isMultiFamily: (_filterState$isMultiF = (_filterState$isMultiF2 = filterState.isMultiFamily) === null || _filterState$isMultiF2 === void 0 ? void 0 : _filterState$isMultiF2.value) !== null && _filterState$isMultiF !== void 0 ? _filterState$isMultiF : true,
      isManufactured: (_filterState$isManufa = (_filterState$isManufa2 = filterState.isManufactured) === null || _filterState$isManufa2 === void 0 ? void 0 : _filterState$isManufa2.value) !== null && _filterState$isManufa !== void 0 ? _filterState$isManufa : true,
      isSingleFamily: (_filterState$isSingle = (_filterState$isSingle2 = filterState.isSingleFamily) === null || _filterState$isSingle2 === void 0 ? void 0 : _filterState$isSingle2.value) !== null && _filterState$isSingle !== void 0 ? _filterState$isSingle : true
    })
  });
  var searchResultState = {
    resultCount: (_srpState$searchResul = (_srpState$searchResul2 = srpState.searchResults) === null || _srpState$searchResul2 === void 0 ? void 0 : (_srpState$searchResul3 = _srpState$searchResul2.listResults) === null || _srpState$searchResul3 === void 0 ? void 0 : _srpState$searchResul3.length) !== null && _srpState$searchResul !== void 0 ? _srpState$searchResul : 0,
    resultsHash: (_srpState$searchResul4 = srpState.searchResults) === null || _srpState$searchResul4 === void 0 ? void 0 : _srpState$searchResul4.resultsHash
  };
  var adAbTrialState = Object.keys(abTrialMappings).reduce(function (trialState, trialName) {
    if (trialName in srpState.abTrials) {
      var trialMapping = abTrialMappings[trialName];
      var treatment = srpState.abTrials[trialName];
      var vers = treatment in trialMapping.vers ? trialMapping.vers[treatment] : '';
      // eslint-disable-next-line no-param-reassign
      trialState[trialName] = {
        treatment: treatment,
        vers: vers,
        slots: trialMapping.slots
      };
    }
    return trialState;
  }, {});
  var adsConfig = srpState.searchList.adsConfig;
  var isAdRestricted = (_srpState$isAdsRestri = srpState.isAdsRestricted) !== null && _srpState$isAdsRestri !== void 0 ? _srpState$isAdsRestri : false;
  var metadata = (_srpState$metadata = srpState.metadata) !== null && _srpState$metadata !== void 0 ? _srpState$metadata : {};

  // convert to array of sorted ids in merge so that we only do this operation when getting in a new state
  // and not whenever our internal state changes
  queryState.regionSelection = collectAndSortRegionIds(srpState);
  return {
    queryState: queryState,
    searchResultState: searchResultState,
    isAdRestricted: isAdRestricted,
    metadata: metadata,
    adsConfig: adsConfig,
    isMobile: (_srpState$searchPageC = (_srpState$searchPageC2 = srpState.searchPageConstants) === null || _srpState$searchPageC2 === void 0 ? void 0 : _srpState$searchPageC2.isMobile) !== null && _srpState$searchPageC !== void 0 ? _srpState$searchPageC : false,
    isTablet: (_srpState$searchPageC3 = (_srpState$searchPageC4 = srpState.searchPageConstants) === null || _srpState$searchPageC4 === void 0 ? void 0 : _srpState$searchPageC4.isTablet) !== null && _srpState$searchPageC3 !== void 0 ? _srpState$searchPageC3 : false,
    adAbTrialState: adAbTrialState
  };
}
function adStateMerger(state, action) {
  if (state === void 0) {
    state = {};
  }
  switch (action.type) {
    case MERGE_AD_STATE:
      {
        return Object.assign({}, state, adStateFromSrpState(action.srpState, action.abTrials));
      }
    default:
      return state;
  }
}

var getDeviceLabel = function getDeviceLabel(appState) {
  var network = '/7449/zillow';
  if (appState.isMobile) {
    return network + "_phone_mweb";
  }
  if (appState.isTablet) {
    return network + "_tablet_mweb";
  }
  return network;
};
var getUnit2 = function getUnit2(appState) {
  var category = appState.queryState.category;
  var searchResult = 'search_results_';
  if (category === 'cat2' && !appState.queryState.filterState.isForRent && !appState.queryState.filterState.isRecentlySold) {
    return searchResult + "2";
  }
  return searchResult + "1";
};
function getAdUnit4(appState, adType) {
  var isAdRestricted = appState.isAdRestricted ? '_restricted' : '';
  var displayPath = "b_right_p1" + isAdRestricted;
  var navPath = "search_1" + isAdRestricted;
  var rentalsPath = "search_2" + isAdRestricted;
  if (adType === AD_SLOTS.NAV) {
    return navPath;
  }
  if (adType === AD_SLOTS.DISPLAY) {
    return displayPath;
  }
  if (adType === AD_SLOTS.RENTAL) {
    return rentalsPath;
  }
  if (adType === AD_SLOTS.NAV2) {
    return rentalsPath;
  }
  return '';
}
function getAdUnit3(appState) {
  var _appState$queryState$;
  var isFSBO = appState.queryState.category === 'cat2' && appState.queryState.filterState.isForSaleByOwner;
  var isFSBA = appState.queryState.filterState.isForSaleByAgent;
  var isNewConstruction = appState.queryState.filterState.isNewConstruction;
  var isComingSoon = (_appState$queryState$ = appState.queryState.filterState.isComingSoon) === null || _appState$queryState$ === void 0 ? void 0 : _appState$queryState$.value;
  var isForeclosure = appState.queryState.filterState.isPreMarketForeclosure || appState.queryState.filterState.isPreMarketPreForeclosure || appState.queryState.filterState.isForSaleForeclosure || appState.queryState.filterState.isAuction;
  var isRecentlySold = appState.queryState.filterState.isRecentlySold;
  var isForRent = appState.queryState.filterState.isForRent;
  var isSingleChecked = (isFSBA ? 1 : 0) + (isFSBO ? 1 : 0) + (isNewConstruction ? 1 : 0) + (isComingSoon ? 1 : 0) + (isForeclosure ? 1 : 0) + (isRecentlySold ? 1 : 0) + (isForRent ? 1 : 0) === 1;
  if (isSingleChecked) {
    if (isFSBA) {
      return 'buy_agent';
    }
    if (isFSBO) {
      return 'buy_owner';
    }
    if (isNewConstruction) {
      return 'buy_new_home';
    }
    if (isComingSoon) {
      return 'buy_commingsoon';
    }
    if (isForeclosure) {
      return 'buy_foreclosure';
    }
    if (isRecentlySold) {
      return 'buy_sold';
    }
    if (isForRent) {
      return 'rent_general';
    }
  }
  return 'buy_general';
}
function createAdPath(appState) {
  var adUnit1 = getDeviceLabel(appState);
  var adUnit2 = getUnit2(appState);
  var supportedList = [AD_SLOTS.DISPLAY, AD_SLOTS.NAV, AD_SLOTS.RENTAL, AD_SLOTS.NAV2];
  var adUnit3 = getAdUnit3(appState);
  var adSlots = Object.assign({}, appState.adSlots);
  supportedList.forEach(function (adType) {
    var adUnit4 = getAdUnit4(appState, adType);
    if (adType === AD_SLOTS.RENTAL && appState.queryState.filterState.isForRent) {
      adSlots[adType] = Object.assign({}, adSlots[adType] || {}, {
        path: adUnit1 + "/" + adUnit2 + "/" + adUnit3 + "/" + adUnit4
      });
    } else if (adType === AD_SLOTS.DISPLAY || adType === AD_SLOTS.NAV || adType === AD_SLOTS.NAV2 && !appState.queryState.filterState.isForRent) {
      adSlots[adType] = Object.assign({}, adSlots[adType] || {}, {
        path: adUnit1 + "/" + adUnit2 + "/" + adUnit3 + "/" + adUnit4
      });
    }
  });
  return {
    adSlots: adSlots
  };
}

/**
 * @function createAdUnitPath
 * @description Creates the ad unit path for the zillow ad slot
 * @param {object} state - The current state of the application
 * @param {object} action - The action that triggered this function
 * @returns {object} The updated state
 */
function createAdUnitPathState(state, action) {
  if (state === void 0) {
    state = {};
  }
  switch (action.type) {
    // when the store is initialized, or
    // filter, category, or restricted status changes, update ad unit paths
    case INITIALIZED_STORE:
      {
        return Object.assign({}, state, createAdPath(state));
      }
    case SRP_STATE_UPDATED:
      {
        if (action.stateChanges.filterStateChanged || action.stateChanges.categoryChanged || action.stateChanges.adRestrictedChanged) {
          return Object.assign({}, state, createAdPath(state));
        }
        return state;
      }
    default:
      return state;
  }
}

function getTreatments(state, slot) {
  var _state$adsConfig$targ, _state$adsConfig, _state$adsConfig$targ2;
  var vers = (_state$adsConfig$targ = (_state$adsConfig = state.adsConfig) === null || _state$adsConfig === void 0 ? void 0 : (_state$adsConfig$targ2 = _state$adsConfig.targets) === null || _state$adsConfig$targ2 === void 0 ? void 0 : _state$adsConfig$targ2.vers) !== null && _state$adsConfig$targ !== void 0 ? _state$adsConfig$targ : '';

  // Rental ad overrides the vers that we get from the ad targets, rather than adding to it.
  if (slot === AD_SLOTS.RENTAL) {
    vers = RENTAL_SECOND_AD_VERS;
  }
  var treatments = null;
  Object.keys(state.adAbTrialState).forEach(function (trialName) {
    var trialState = state.adAbTrialState[trialName];
    if (trialState.slots.includes(slot)) {
      vers = versAppend(vers, trialState.vers);
      treatments = treatments || {};
      treatments[trialName] = trialState.treatment;
    }
  });
  return {
    treatments: treatments,
    vers: vers
  };
}
function updateSlotsTreatmentsAndVers(state) {
  var newAdSlotState = Object.keys(AD_SLOTS).reduce(function (newState, slotKey) {
    var slot = AD_SLOTS[slotKey];
    // eslint-disable-next-line no-param-reassign
    newState[slot] = Object.assign({}, ((state === null || state === void 0 ? void 0 : state.adSlots) || {})[slot], getTreatments(state, slot));
    return newState;
  }, {});
  return {
    adSlots: newAdSlotState
  };
}
function abTrialReducer(state, action) {
  if (state === void 0) {
    state = {};
  }
  switch (action.type) {
    case SRP_STATE_UPDATED:
      if (action.stateChanges.abTrialState) {
        return Object.assign({}, state, updateSlotsTreatmentsAndVers(state));
      }
      return state;
    case INITIALIZED_STORE:
      {
        return Object.assign({}, state, updateSlotsTreatmentsAndVers(state));
      }
    default:
      return state;
  }
}

var shouldShowRentalAd = function shouldShowRentalAd(state) {
  return state.queryState.filterState.isForRent && state.searchResultState.resultCount > 2;
};
var shouldShowNavAd = function shouldShowNavAd(state) {
  return state.searchResultState.resultCount > 2;
};
function shouldShowAd(state, slot) {
  if (slot === AD_SLOTS.RENTAL) {
    return shouldShowRentalAd(state);
  }
  if (slot === AD_SLOTS.NAV2) {
    return !state.queryState.filterState.isForRent && shouldShowNavAd(state);
  }
  // currently display and nav ad have the same rules for display purposes
  return shouldShowNavAd(state);
}
function handleInitializedStore(state) {
  var newAdSlotState = Object.keys(AD_SLOTS).reduce(function (newState, slotKey) {
    var slot = AD_SLOTS[slotKey];
    // eslint-disable-next-line no-param-reassign
    newState[slot] = Object.assign({}, ((state === null || state === void 0 ? void 0 : state.adSlots) || {})[slot], {
      showAd: shouldShowAd(state, slot),
      refreshAd: false,
      destroyAd: false
    });
    return newState;
  }, {});
  return newAdSlotState;
}
function destroyAdSlots(state) {
  return Object.keys(AD_SLOTS).reduce(function (newState, slotKey) {
    var slot = AD_SLOTS[slotKey];
    // eslint-disable-next-line no-param-reassign
    newState[slot] = Object.assign({}, ((state === null || state === void 0 ? void 0 : state.adSlots) || {})[slot], {
      showAd: shouldShowAd(state, slot),
      destroyAd: true
    });
    return newState;
  }, {});
}
var shouldRefreshNavAd = function shouldRefreshNavAd(state, action, slot) {
  if (Date.now() - state.adSlots[slot].requestTime < 10000) {
    return false;
  }
  if (action.stateChanges.pageChanged) {
    return true;
  }
  if (isRefreshFilterChange(state, action)) {
    return true;
  }
  if (action.stateChanges.userSearchTermChanged) {
    return true;
  }
  if (state.queryState.mapZoom < 15 || !action.stateChanges.mapBoundsChanged) {
    return false;
  }
  if (state.queryState.regionSelection.length > 1) {
    return action.stateChanges.regionSelectionChanged;
  }
  if (isEligibleForZipCodeRefresh(state)) {
    return action.stateChanges.zipCodeChanged;
  }
  return action.stateChanges.searchResultsChanged;
};
var handleSrpStateUpdateForNav = function handleSrpStateUpdateForNav(state, action, slot) {
  if (isListingTypeFilterChange(action.previousFilterState, state.queryState.filterState)) {
    return {
      destroyAd: true,
      refreshAd: false
    };
  }
  if (action.stateChanges.categoryChanged) {
    return {
      destroyAd: true,
      refreshAd: false
    };
  }
  return {
    refreshAd: shouldRefreshNavAd(state, action, slot)
  };
};
var handleSrpStateUpdateForSlot = function handleSrpStateUpdateForSlot(state, action, slot) {
  var showAd = shouldShowAd(state, slot);
  var adState = handleSrpStateUpdateForNav(state, action, slot);
  if (adState.destroyAd && !showAd) {
    adState.requestTime = undefined;
  }
  return Object.assign({}, adState, {
    showAd: showAd
  });
};
var handleSrpStateUpdate = function handleSrpStateUpdate(state, action) {
  if (action.stateChanges.adRestrictedChanged) {
    return destroyAdSlots(state);
  }
  var newAdSlotState = Object.keys(AD_SLOTS).reduce(function (newState, slotKey) {
    var slot = AD_SLOTS[slotKey];
    // eslint-disable-next-line no-param-reassign
    newState[slot] = Object.assign({}, ((state === null || state === void 0 ? void 0 : state.adSlots) || {})[slot], handleSrpStateUpdateForSlot(state, action, slot));
    return newState;
  }, {});
  return newAdSlotState;
};
function businessRuleValidator(state, action) {
  var _Object$assign;
  if (state === void 0) {
    state = {};
  }
  var requestTime = Date.now();
  switch (action.type) {
    case INITIALIZED_STORE:
      // Set display ad state based on the initial srp state
      return Object.assign({}, state, {
        adSlots: handleInitializedStore(state)
      });
    case SRP_STATE_UPDATED:
      return Object.assign({}, state, {
        adSlots: handleSrpStateUpdate(state, action)
      });
    case AD_SLOT_REQUESTED:
      return Object.assign({}, state, {
        adSlots: Object.assign({}, state.adSlots, (_Object$assign = {}, _Object$assign[action.slot] = Object.assign({}, state.adSlots[action.slot], {
          requestTime: requestTime,
          refreshAd: false,
          destroyAd: false
        }), _Object$assign))
      });
    default:
      return state;
  }
}

// call all reducers
function adStateReducer(state, action) {
  var updatedState = Object.assign({}, state);
  updatedState = adStateMerger(updatedState, action);
  updatedState = createAdUnitPathState(updatedState, action);
  updatedState = abTrialReducer(updatedState, action);
  updatedState = businessRuleValidator(updatedState, action);
  // TODO: add the other reducers
  return updatedState;
}

function initializedStore() {
  return {
    type: INITIALIZED_STORE
  };
}
function srpStateUpdated(stateChanges, previousFilterState) {
  return {
    type: SRP_STATE_UPDATED,
    stateChanges: stateChanges,
    previousFilterState: previousFilterState
  };
}

var name = "@zillow/ad-state-machine";
var version = "1.0.9";
var description = "";
var main = "./dist/ad-state-machine.js";
var scripts = {
  prepare: "npm run build",
  build: "znpm-scripts build --bundle",
  format: "znpm-scripts format",
  lint: "znpm-scripts lint",
  test: "znpm-scripts test --coverage --passWithNoTests",
  "test:watch": "znpm-scripts test",
  "test:update": "znpm-scripts test --updateSnapshot",
  validate: "znpm-scripts validate",
  watch: "znpm-scripts build --bundle --watch"
};
var repository = {
  type: "git",
  url: "https://gitlab.zgtools.net/media-solutions-technology/mst-components/project-machina.git"
};
var husky = {
  hooks: {
    "pre-commit": "znpm-scripts pre-commit"
  }
};
var keywords = [];
var author = "";
var license = "ISC";
var devDependencies = {
  "@babel/plugin-proposal-optional-chaining": "^7.21.0",
  "@babel/plugin-proposal-private-property-in-object": "^7.21.11",
  "@types/jest": "^29.5.14",
  "@zillow/znpm-scripts": "^4.4.1",
  jest: "^29.7.0"
};
var peerDependencies = {
  "@reduxjs/toolkit": "^2.5.0",
  "@sentry/react": ">=7.119.0",
  react: "^18.3.1",
  "react-redux": "^7.2.1"
};
var dependencies = {
  "@zillow/mst-sentry": "^1.0.5",
  "react-fast-compare": "^3.2.0"
};
var pjson = {
  name: name,
  version: version,
  description: description,
  main: main,
  scripts: scripts,
  repository: repository,
  husky: husky,
  keywords: keywords,
  author: author,
  license: license,
  devDependencies: devDependencies,
  peerDependencies: peerDependencies,
  dependencies: dependencies
};

var SentryHelper = /*#__PURE__*/function () {
  function SentryHelper() {
    var env = process.env.NODE_ENV || 'production';
    var version = pjson.version;
    this.sentryScope = mstSentry.initMstSentryScope(SENTRY.PROJECT_NAME, SENTRY.DSN, env, "machina_" + version);
  }
  var _proto = SentryHelper.prototype;
  _proto.captureException = function captureException(error) {
    console.error(error);
    this.sentryScope.captureException(error);
  };
  return SentryHelper;
}();
var sentryHelper = new SentryHelper();

var sentryReducerEnhancer = function sentryReducerEnhancer(store) {
  return function (reducer, initialState, enhancer) {
    var sentryReducer = function sentryReducer(state, action) {
      try {
        var newState = reducer(state, action);
        return newState;
      } catch (error) {
        sentryHelper.captureException(error);
        return state;
      }
    };
    return store(sentryReducer, initialState, enhancer);
  };
};
var store = null;
function createAdStateStore(srpState, abTrialMapping) {
  if (store) {
    return store;
  }
  var initialState = adStateFromSrpState(srpState, abTrialMapping);
  store = toolkit.configureStore({
    reducer: adStateReducer,
    middleware: function middleware(getDefaultMiddleware) {
      return getDefaultMiddleware();
    },
    enhancers: function enhancers(getDefaultEnhancers) {
      return [sentryReducerEnhancer].concat(_toConsumableArray(getDefaultEnhancers()));
    },
    devTools: {
      name: 'mst-machina'
    },
    preloadedState: initialState
  });
  var currentState = initialState;
  store.subscribe(function () {
    var previousState = currentState;
    currentState = store.getState();
    var stateChanges = getStateChanges(previousState, currentState);
    if (stateChanges.userSearchTermChanged || stateChanges.mapZoomChanged || stateChanges.filterStateChanged || stateChanges.mapBoundsChanged || stateChanges.regionSelectionChanged || stateChanges.abTrialStateChanged || stateChanges.zipCodeChanged || stateChanges.searchResultsChanged || stateChanges.pageChanged || stateChanges.adRestrictedChanged || stateChanges.categoryChanged) {
      store.dispatch(srpStateUpdated(stateChanges, previousState.queryState.filterState));
    }
  });
  store.dispatch(initializedStore());
  return store;
}

function mergeSrpState(srpState, abTrials) {
  return {
    type: MERGE_AD_STATE,
    srpState: srpState,
    abTrials: abTrials
  };
}

var _excluded = ["children", "abTrialMapping"];
var _jsxFileName = "/builds/media-solutions-technology/mst-components/project-machina/src/AdStateProvider.jsx",
  _this = undefined;
var listResults = null;
var AdStateProvider = function AdStateProvider(_ref) {
  var children = _ref.children,
    abTrialMapping = _ref.abTrialMapping,
    rest = _objectWithoutProperties(_ref, _excluded);
  var srpState = reactRedux.useSelector(function (state) {
    var _state$searchList$ads, _state$searchList$ads2, _state$searchPageCons, _state$searchPageCons2, _state$uiState$applyL, _state$uiState;
    return {
      queryState: state.queryState,
      isAdsRestricted: (_state$searchList$ads = (_state$searchList$ads2 = state.searchList.adsConfig) === null || _state$searchList$ads2 === void 0 ? void 0 : _state$searchList$ads2.restrictedAds) !== null && _state$searchList$ads !== void 0 ? _state$searchList$ads : true,
      searchResults: state.searchResults,
      searchPageConstants: {
        isMobile: (_state$searchPageCons = state.searchPageConstants) === null || _state$searchPageCons === void 0 ? void 0 : _state$searchPageCons.isMobile,
        isTablet: (_state$searchPageCons2 = state.searchPageConstants) === null || _state$searchPageCons2 === void 0 ? void 0 : _state$searchPageCons2.isTablet
      },
      searchList: {
        adsConfig: state.searchList.adsConfig
      },
      abTrials: state.abTrials,
      metadata: rest,
      adSlots: (state === null || state === void 0 ? void 0 : state.adSlots) || {},
      searchResultUpdateCount: (_state$uiState$applyL = (_state$uiState = state.uiState) === null || _state$uiState === void 0 ? void 0 : _state$uiState.applyListResultsCount) !== null && _state$uiState$applyL !== void 0 ? _state$uiState$applyL : 0
    };
  }, isEqual__default);
  var store = createAdStateStore(srpState, abTrialMapping);
  React.useEffect(function () {
    if (listResults !== srpState.searchResults.listResults) {
      // eslint-disable-next-line prefer-destructuring
      listResults = srpState.searchResults.listResults;
      store.dispatch(mergeSrpState(srpState, abTrialMapping));
    }
  }, [srpState, store, abTrialMapping]);
  return /*#__PURE__*/React__default.createElement(mstSentry.MstSentry, {
    sentryScope: sentryHelper.sentryScope,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 9
    }
  }, /*#__PURE__*/React__default.createElement(reactRedux.Provider, {
    store: store,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 13
    }
  }, children));
};

function adSlotRequested(slot) {
  return {
    type: AD_SLOT_REQUESTED,
    slot: slot
  };
}

exports.AD_SLOTS = AD_SLOTS;
exports.AdStateProvider = AdStateProvider;
exports.adSlotRequested = adSlotRequested;
